(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('MoveEventsController', MoveEventsController);

    MoveEventsController.$inject = ['EventsService', '$rootScope', '$controller','$sce', '$uibModalInstance', 'entity', 'AlertService', 'parameters', 'SoopkitchenUtils'];
    
    function MoveEventsController(EventsService, $rootScope, $controller, $sce, $uibModalInstance, entity, AlertService, parameters, SoopkitchenUtils) {

        var vm = this;

        /**** Properties ****/

        vm.planLabel =  parameters.planLabel;
        vm.events =  parameters.events;
        vm.anchorTime =  parameters.anchorDate;
        vm.planType =  parameters.planType;
        vm.cut =  parameters.cut;

        var titlePrefix = "Copy and paste ";
        if (vm.cut) titlePrefix = "Cut and paste "; 
        
        var title = titlePrefix + vm.events.length + ' events';
        angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": title, $sce: $sce, $uibModalInstance: $uibModalInstance}));

        //Overriding Properties from SoopkitchenDialogController:
        vm.saveDisabled = false;
        vm.saveText = "Apply";

        /**** Methods ****/
        vm.isValidDate = isValidDate;

        //Override Methods from SoopkitchenDialogController
        vm.save = moveEvents;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function isValidDate(date) {
            if (date == null || date === '') {
                vm.saveDisabled = true;
                return false;
            }
            vm.saveDisabled = false === SoopkitchenUtils.isValidDate(date);
            return SoopkitchenUtils.isValidDate(date);
        }

        function successCallback(response) {
            return function() {
                SoopkitchenUtils.updatePlanFromDialog(response.data);
                $uibModalInstance.dismiss('cancel');
            }
        }
        
        function moveEvents() {
            EventsService.moveEvents(vm.planType, vm.planLabel, vm.events, vm.anchorTime, vm.cut, successCallback);
        }    
        
    }
})();
